import keycloak from "./keycloak";

export async function apiFetch_(url, options = {}) {
  await keycloak.updateToken(30);

  const response = await fetch(
    `${url}`,
    {
      //...options,
      headers: {
        Authorization: `Bearer ${keycloak.token}`,
        ...(options.headers || {}),
      },
    }
  );

  if (response.status === 401) {
    keycloak.login();
    return;
  }

  return response;
}
export async function apiFetch(url, options = {}) {
  await keycloak.updateToken(30);

  const response = await fetch(
    `${process.env.REACT_APP_BACKEND_URL}${url}`,
    {
      ...options,
      // headers: {
      //   "Content-Type": "application/json",
      //   Authorization: `Bearer ${keycloak.token}`,
      //   ...(options.headers || {}),
      // },
    }
  );

  if (response.status === 401) {
    keycloak.login();
    return;
  }

  return response;
}